import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { showError } from '_metronic/helpers'
import { PageHeading } from 'app/components'
import { getUserById } from '../../../usuarios/usuarios-list/core/_requests'

/** Cabeçalho da tela de logs de um usuário, acima do <TableCard>: nome e e-mail. */
export const LogsUsuarioHeading = () => {
  const { id } = useParams<{ id: string }>()

  const { data: usuario, isError } = useQuery(
    ['logs-usuario-atual', id],
    () => getUserById(Number(id)),
    { enabled: Boolean(id), refetchOnWindowFocus: false, onError: showError }
  )

  const nome = usuario?.nomeSocial || usuario?.nome
  const titulo = nome ?? (isError ? 'Usuário' : 'Carregando usuário…')

  return <PageHeading title={titulo} description={usuario?.email} />
}
